import React from "react";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";

const StyledWordmark = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: auto;
  width: 9rem;
  height: 0.9rem;
  filter: invert(${(props) => (props.color === "black" ? 1 : 0)});

  &:hover {
    cursor: pointer;
    opacity: 0.9;
  }
`;

const Wordmark = ({ color, img, ...props }) => {
  return (
    <StyledWordmark color={color}>
      <StaticImage
        placeholder="blurred"
        src="../../images/KingChildren/wordmark.png"
        alt="KING CHILDREN"
        imgStyle={{
          objectFit: "contain",
          objectPosition: "left center",
        }}
      />
    </StyledWordmark>
  );
};

const KCLogo = ({ handleClick, color, ...props }) => {
  return <Wordmark color={color} />;
};

export { StyledWordmark, KCLogo };
